import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  inputRow: {
    margin: theme.spacing(1, 0),
  },
  title: {
    margin: theme.spacing(3, 0),
  },
  calendarWrapper: {
    margin: theme.spacing(1, 0),
  },
  tableFormWrapper: {
    marginBottom: theme.spacing(4),
  },
  tableWrapper: {
    marginBottom: theme.spacing(4),
  },
}));

export default useStyles;
